import { Grid } from '@mui/material'
import React from 'react'

interface FooterProps {
  rightActions?: React.ReactNode
}

const Footer: React.FC<FooterProps> = ({ rightActions = null }) => (
  <Grid container size={{ xs: 12 }} sx={{ justifyContent: 'flex-end' }}>
    <Grid size={{ xs: 8 }}>{rightActions}</Grid>
  </Grid>
)

export default Footer
